import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import { EFilteringState } from "../../../utils/enums/EFilteringState.ts";
import { EOrder } from "../../../utils/enums/ESortingOrder.ts";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { BookingsResponse } from "./type.ts";

type useBookingParams = {
  startDate?: string | null;
  endDate?: string | null;
  hallId?: number | string | null;
  clientId?: number | string | null;
  page: number;
  pageSize: number;
  sendDeleted?: boolean;
  order?: EOrder;
  filtering?: EFilteringState;
};

export const useBookings = (params: useBookingParams) => {
  const { token } = useAuth();
  const { startDate, endDate, hallId, pageSize, page, clientId, sendDeleted = true, order, filtering } = params;

  const fetch = useFetch();

  const { data, isFetching, isError , refetch, isPending, error } = useQuery<
    BookingsResponse | null,
    Error,
    BookingsResponse
  >({
    queryKey: ["bookings", startDate, endDate, hallId, pageSize, page, clientId, sendDeleted, order, filtering],
    enabled: !!(pageSize && page),
    queryFn: () =>
      fetch<BookingsResponse>(`${Urls.Booking}?page=${page}&pageSize=${pageSize}&${startDate ? `startDate=${startDate}&` : ""}${endDate ? `endDate=${endDate}&` : ""}${order ? `order=${order}&` : ""}${filtering ? `filtering=${filtering}&` : ""}${hallId ? `hallId=${hallId}&` : ""}${clientId ? `clientId=${clientId}&` : ""}${`sendDeleted=${sendDeleted}`}`, {
        method: "GET",
      }, true, token),
    //refetchInterval: 60000,
    staleTime: 0,
    gcTime: 0
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting bookings");
    }
  }, [isError, error]);

  return {
    data,
    isFetching,
    refetch,
    isPending
  };
};
